import { Separator as BaseSeparator } from '@change-corgi/design-system-legacy/components/content';

/**
 * Renders a horizontal rule with vertical margin. This is a thin wrapper around the design system (legacy) to maintain
 * consistency across the petition page. It may be made irrelevant by spacing rules in the new design system.
 *
 * Note: Also passes role="presentation" so that the section break is not announced to screen readers. The break between
 * sections is indicated by heading elements.
 */
export const Separator: React.FC = () => <BaseSeparator role="presentation" my={24} />;
